import React, { useState } from 'react';

import classNames from 'classnames';

import { AssignmentTypeEnum } from '@school_ify/schoolify-repository/src/shared/types';

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as OptionsIcon } from 'assets/icons/options.svg';
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg';
import { ReactComponent as EyeClosedIcon } from 'assets/icons/eyeClosed.svg';
import { ReactComponent as ExportIcon } from 'assets/icons/export.svg';
import Button from 'clean/components/common/Button/Button';
import ButtonDropDown from 'clean/components/common/ButtonDropDown/ButtonDropDown';

import styles from './MarksTableHeader.module.scss';
import { ViewMode } from '../MarksTable/MarksTable';
import SwitchModal from '../SwitchModal/SwitchModal';

interface Props {
  setViewMode: (viewMode: ViewMode) => void;
  viewMode: ViewMode;
}

const MarksTableHeader: React.FC<Props> = ({ viewMode, setViewMode }) => {
  const viewModes = [
    { id: ViewMode.date, label: 'Date' },
    { id: ViewMode.compact, label: 'Compact' },
  ];

  const assignmentTypes = [
    { id: AssignmentTypeEnum.TASK, label: 'Task' },
    { id: AssignmentTypeEnum.QUIZ, label: 'Quiz' },
    { id: AssignmentTypeEnum.STUDY, label: 'Study' },
    { id: AssignmentTypeEnum.HAUSAUFGABE, label: 'Homework' },
  ];
  const [assigmnmentTypes, setAssigmnmentTypes] = useState<AssignmentTypeEnum[]>([]);
  const [showSwitchModal, setShowSwitchModal] = useState(false);

  return (
    <div className={styles.container}>
      {showSwitchModal && <SwitchModal onClose={() => setShowSwitchModal(false)} />}
      <div className={styles.title}>6B Mathematics</div>
      <div className={styles.action}>
        <ButtonDropDown
          paddingVertical={7}
          value={null}
          variant="secondary"
          childrenElementPos="top.center"
          targetElementPos="bottom.center"
          emptyItemLabel="Options"
          showChevron={false}
          iconStart={<OptionsIcon />}
          renderPanel={({ classes: defaultClasses, close }) => {
            return (
              <>
                <div className={defaultClasses.groupTitle}>Table view</div>
                {viewModes.map(item => {
                  return (
                    <div
                      key={item.id}
                      className={classNames(defaultClasses.outer, {
                        [defaultClasses.outerSelected]: viewMode === item.id,
                        [styles.optionSelected]: viewMode === item.id,
                      })}
                    >
                      <div
                        className={defaultClasses.inner}
                        onClick={() => {
                          setViewMode(item.id);
                          close();
                        }}
                      >
                        {item.label}
                      </div>
                    </div>
                  );
                })}
                <div className={defaultClasses.groupTitle}>Grade type</div>
                {assignmentTypes.map(item => {
                  return (
                    <div key={item.id} className={defaultClasses.outer}>
                      <div
                        className={classNames(defaultClasses.inner, styles.assignmentType)}
                        onClick={() => {
                          setAssigmnmentTypes(
                            assigmnmentTypes.includes(item.id)
                              ? assigmnmentTypes.filter(i => i !== item.id)
                              : [...assigmnmentTypes, item.id]
                          );
                          close();
                        }}
                      >
                        {item.label}
                        {assigmnmentTypes.includes(item.id) ? (
                          <EyeIcon className={styles.eyeIcon} />
                        ) : (
                          <EyeClosedIcon className={styles.eyeIcon} />
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            );
          }}
        />
      </div>
      <div className={styles.action}>
        <ButtonDropDown
          paddingVertical={7}
          value={null}
          variant="secondary"
          childrenElementPos="top.center"
          targetElementPos="bottom.center"
          emptyItemLabel="Export"
          options={[
            { id: 'CSV', label: 'CSV' },
            { id: 'PDF', label: 'PDF' },
            { id: 'JPEG', label: 'JPEG' },
          ]}
          showChevron={false}
          showSelectedOption={false}
          iconStart={<ExportIcon />}
        />
      </div>
      <div className={styles.action}>
        <Button
          onClick={() => setShowSwitchModal(true)}
          label="Add attendance"
          color="primary"
          variant="filled"
          startIcon={<PlusIcon />}
        />
      </div>
    </div>
  );
};

export default MarksTableHeader;
